import Contenedor from '../../../components/common/Contenedor';
import { Menu } from './menu';

export const ModuloCortesRestaurante = () => {
  return (
    <Contenedor title="Modulo de Cortes" children={<Menu />} />
  )
}
